<div class="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
  <div
    class="bg-white rounded-lg shadow-lg px-6 pt-6 w-full max-w-7xl max-h-[90vh] overflow-y-auto"
  >
    <app-loading *ngIf="isLoading; else content"></app-loading>
    <ng-template #content>
      <h2 class="text-lg font-bold mb-4">Actualizar oferta de empleo</h2>
      <form
        [formGroup]="jobOfferForm"
        (ngSubmit)="onUpdateClick()"
        class="space-y-6"
      >
        <div class="grid grid-cols-1 md:grid-cols-5 gap-6">
          <app-input-select
            label="Área"
            placeholder="Seleccione area"
            [control]="jobOfferForm.get('idArea')"
            [options]="areas"
          >
          </app-input-select>
          <app-input-select
            label="Educación"
            placeholder="Seleccione educación"
            [control]="jobOfferForm.get('idEducation')"
            [options]="educations"
          >
          </app-input-select>
          <app-input-select
            label="Modalidad de empleo"
            placeholder="Seleccione modalidad"
            [control]="jobOfferForm.get('idJobType')"
            [options]="employmentTypes"
          >
          </app-input-select>
          <app-input-select
            label="Título de empleo"
            placeholder="Seleccione título"
            [control]="jobOfferForm.get('idJobTitle')"
            [options]="jobTitles"
          >
          </app-input-select>
          <app-input-select
            label="Profesión"
            placeholder="Seleccione profesión"
            [control]="jobOfferForm.get('idProfession')"
            [options]="professions"
          >
          </app-input-select>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <app-input-text
            label="Título de oferta"
            placeholder="Ejemplo: Desarrollador web"
            [control]="jobOfferForm.get('title')"
          />
          <app-input-text
            label="Subtítulo"
            placeholder="Ejemplo: Proyecto de tesis"
            [control]="jobOfferForm.get('subTitle')"
          />
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">
            Descripción
          </label>
          <ckeditor
            [editor]="Editor"
            [config]="editorConfig"
            formControlName="description"
            class="w-full z-0 text-gray-900 placeholder-gray-500 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary editor-area"
          >
          </ckeditor>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-5 gap-6">
          <app-input-text
            label="Edad mínima"
            placeholder="18"
            [control]="jobOfferForm.get('minimumAge')"
          />
          <app-input-text
            label="Edad máxima"
            placeholder="45"
            [control]="jobOfferForm.get('maximumAge')"
          />
          <app-input-text
            label="Experiencia (años)"
            placeholder="1"
            [control]="jobOfferForm.get('minimumExperience')"
          />
          <app-input-text
            label="Número de vacantes"
            placeholder="10"
            [control]="jobOfferForm.get('numberVacancies')"
          />
          <div class="flex items-center gap-2 mt-8">
            <input
              type="checkbox"
              formControlName="hasRemuneration"
              id="hasRemuneration"
              class="accent-primary w-4 h-4"
            />
            <label
              for="hasRemuneration"
              class="text-sm text-gray-700 flex items-center gap-1"
            >
              Tiene remuneración
              <span class="relative group">
                <ng-icon
                  name="heroInformationCircle"
                  class="text-gray-400 w-4 h-4 cursor-pointer"
                ></ng-icon>
                <span
                  class="absolute w-32 -left-32 bottom-3 -translate-y-1/2 hidden group-hover:block bg-gray-800 text-white text-xs px-2 py-1 rounded shadow-lg"
                >
                  Indica si este puesto recibirá un pago.
                </span>
              </span>
            </label>
          </div>
        </div>
        <div
          class="grid grid-cols-1 md:grid-cols-3 gap-6"
          *ngIf="jobOfferForm.get('hasRemuneration')?.value"
        >
          <app-input-text
            label="Salario mínimo"
            placeholder="1200"
            [control]="jobOfferForm.get('minimumSalary')"
          />
          <app-input-text
            label="Salario máximo"
            placeholder="3500"
            [control]="jobOfferForm.get('maximumSalary')"
          />
          <div class="flex items-center gap-2 mt-8">
            <input
              type="checkbox"
              formControlName="showSalary"
              id="showSalary"
              class="accent-primary w-4 h-4"
            />
            <label
              for="showSalary"
              class="text-sm text-gray-700 flex items-center gap-1"
            >
              Mostrar salario
              <span class="relative group">
                <ng-icon
                  name="heroInformationCircle"
                  class="text-gray-400 w-4 h-4 cursor-pointer"
                ></ng-icon>
                <span
                  class="absolute w-32 -left-32 bottom-3 -translate-y-1/2 hidden group-hover:block bg-gray-800 text-white text-xs px-2 py-1 rounded shadow-lg"
                >
                  Si está activado, el salario será visible en la publicación.
                </span>
              </span>
            </label>
          </div>
        </div>
        <div class="flex justify-end gap-2 sticky bottom-0 bg-white pt-4 pb-6">
          <button
            type="button"
            (click)="onCloseClick()"
            class="px-4 py-2 bg-gray-200 rounded shadow"
          >
            Cancelar
          </button>
          <app-loading-button
            [text]="'Guardar'"
            [loading]="loading"
            type="submit"
          >
          </app-loading-button>
        </div>
      </form>
    </ng-template>
  </div>
</div>
